// src/components/settings/CancelSubscriptionModal.tsx

import {
  Button,
  Flex,
  Text,
  DialogRoot,
  DialogBackdrop,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
  DialogCloseTrigger,
  DialogPositioner,
  Portal,
} from '@chakra-ui/react'
import { LuX } from 'react-icons/lu'

type CancelSubscriptionModalProps = {
  isOpen: boolean
  onClose: () => void
  onCancel?: () => void // Abbrechen
  onConfirm?: () => Promise<void> | void
}

export function CancelSubscriptionModal({
  isOpen,
  onClose,
  onCancel,
  onConfirm,
}: CancelSubscriptionModalProps) {
  // Map Chakra v3's `open` / `onOpenChange` to your isOpen/onClose props
  const handleOpenChange = (details: { open: boolean }) => {
    if (!details.open) {
      onClose()
    }
  }

  const handleCancel = () => {
    onCancel?.()
    onClose()
  }

  // change handleConfirm to async + await:
  const handleConfirm = async () => {
    await onConfirm?.() // ✅ wait for API
    onClose()
  }

  return (
    <DialogRoot open={isOpen} onOpenChange={handleOpenChange} scrollBehavior="inside">
      <Portal>
        <DialogBackdrop />

        <DialogPositioner>
          <DialogContent maxW="420px" position="relative">
            <DialogHeader>
              <DialogTitle>Vertrag kündigen</DialogTitle>
            </DialogHeader>

            {/* Top-right close icon, no extra callbacks */}
            <DialogCloseTrigger asChild>
              <Button aria-label="Dialog schließen" variant="ghost">
                <LuX />
              </Button>
            </DialogCloseTrigger>

            <DialogBody>
              <Text>
                Möchten Sie den Vertrag zum Ende der aktuellen Vertragslaufzeit kündigen? Das
                SIB-Portal kann bis zum Vertragsende weiterhin genutzt werden.
              </Text>

              <DialogFooter>
                <Flex justify="flex-end" gap="3" w="full">
                  <Button variant="outline" onClick={handleCancel}>
                    Abbrechen
                  </Button>
                  <Button colorPalette="red" onClick={handleConfirm}>
                    Vertrag kündigen
                  </Button>
                </Flex>
              </DialogFooter>
            </DialogBody>
          </DialogContent>
        </DialogPositioner>
      </Portal>
    </DialogRoot>
  )
}
